/**
 * restrictionEngine.js — Re Leve IA (Etapa 5)
 * Registra restrições alimentares declaradas pelo usuário na sessão local.
 * Regra: não assumir restrição sem declaração explícita do cliente.
 */

import {
  getStoredRestrictions,
  setStoredRestriction,
  addSessionEvent,
} from './localStorageEngine';

// Padrões de detecção de restrições
const RESTRICTION_PATTERNS = [
  { type: 'sem_lactose',    label: 'Sem lactose',    patterns: ['sem lactose', 'intoler.*lactose', 'lactose'] },
  { type: 'sem_gluten',     label: 'Sem glúten',     patterns: ['sem gl[uú]ten', 'intoler.*gl[uú]ten', 'gl[uú]ten', 'cel[ií]aco'] },
  { type: 'low_carb',       label: 'Low carb',       patterns: ['low.?carb', 'baixo.?carb', 'pouco.?carb'] },
  { type: 'vegetariano',    label: 'Vegetariano',    patterns: ['vegetariano', 'sem carne'] },
  { type: 'vegano',         label: 'Vegano',         patterns: ['vegano', 'vegan'] },
  { type: 'alergia',        label: 'Alergia',        patterns: ['alergi', 'al[eé]rgico'] },
  { type: 'intolerancia',   label: 'Intolerância',   patterns: ['intoler[aâ]ncia', 'intolerante'] },
];

function normalizeText(text) {
  return (text || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim();
}

export function detectDeclaredRestriction(message) {
  const normalized = normalizeText(message);
  const detected = [];

  for (const restriction of RESTRICTION_PATTERNS) {
    for (const pattern of restriction.patterns) {
      const regex = new RegExp(pattern, 'i');
      if (regex.test(normalized)) {
        detected.push({
          type: restriction.type,
          label: restriction.label,
          rawPattern: pattern,
          isGraveAlert: restriction.type === 'alergia',
        });
        break;
      }
    }
  }

  return detected;
}

export function saveDeclaredRestriction(clienteId, restriction) {
  if (!clienteId) return null;
  const record = setStoredRestriction(clienteId, {
    type: restriction.type,
    label: restriction.label,
    declaredByUser: true,
    isGraveAlert: restriction.isGraveAlert || false,
  });
  addSessionEvent(clienteId, {
    eventType: 'restriction_declared',
    description: `Cliente declarou restrição: ${restriction.label}`,
    restrictionType: restriction.type,
  });
  return record;
}

export function getDeclaredRestrictions(clienteId) {
  if (!clienteId) return [];
  return getStoredRestrictions(clienteId);
}

export function hasDeclaredRestriction(clienteId) {
  return getDeclaredRestrictions(clienteId).length > 0;
}

export function hasGraveAllergyAlert(clienteId) {
  return getDeclaredRestrictions(clienteId).some(r => r.isGraveAlert);
}

export function getRestrictionsSummary(clienteId) {
  const restrictions = getDeclaredRestrictions(clienteId);
  if (restrictions.length === 0) return null;
  return restrictions.map(r => r.label).join(', ');
}
